<template>
  <div class="customized_service">
    <div class="banner">
      <div class="banner_text">
        <h4>
          「量体裁衣」定制企业专属的解决方案
        </h4>
        <h6>
          从用户真正需求出发 竭诚为用户解决问题
        </h6>
        <div class="button" @click="contact" style="cursor:pointer;">立即咨询</div>
      </div>
    </div>
    <div class="content1">
      <h5>四大亮点，核心优势</h5>
      <ul>
        <li>
          <img src="../../assets/img/customized_service/advantage_1.png" />
          <h6>个性化定制</h6>
          <p>根据企业需求</p>
          <p>功能量身定制</p>
        </li>
        <li>
          <img src="../../assets/img/customized_service/advantage_2.png" />
          <h6>技术支持</h6>
          <p>全程一对一服务</p>
          <p>24小时技术支持</p>
        </li>
        <li>
          <img src="../../assets/img/customized_service/advantage_3.png" />
          <h6>集成对接</h6>
          <p>企业OA无缝对接</p>
          <p>操作数据实时同步</p>
        </li>
        <li>
          <img src="../../assets/img/customized_service/advantage_4.png" />
          <h6>信息保密性</h6>
          <p>数据加密储存</p>
          <p>保障数据安全</p>
        </li>
      </ul>
    </div>
    <div class="content2">
      <h5>本地化部署服务</h5>
      <ul>
        <li>
          <img src="../../assets/img/customized_service/step_1.png" />
          <h6>需求洽谈</h6>
          <p>step 1</p>
        </li>
        <li><img src="../../assets/img/customized_service/arrow.png"></li>
        <li>
          <img src="../../assets/img/customized_service/step_2.png" />\
          <h6>方案报价</h6>
          <p>step 2</p>
        </li>
        <li><img src="../../assets/img/customized_service/arrow.png"></li>
        <li>
          <img src="../../assets/img/customized_service/step_3.png" />
          <h6>签订合同</h6>
          <p>step 3</p>
        </li>
        <li><img src="../../assets/img/customized_service/arrow.png"></li>
        <li>
          <img src="../../assets/img/customized_service/step_4.png" />
          <h6>技术开发</h6>
          <p>step 4</p>
        </li>
        <li><img src="../../assets/img/customized_service/arrow.png"></li>
        <li>
          <img src="../../assets/img/customized_service/step_5.png" />
          <h6>系统测试</h6>
          <p>step 5</p>
        </li>
        <li><img src="../../assets/img/customized_service/arrow.png"></li>
        <li>
          <img src="../../assets/img/customized_service/step_6.png" />
          <h6>验收上线</h6>
          <p>step 6</p>
        </li>
      </ul>
      
    </div>
    <el-dialog
      :visible.sync="videoVisible"
      width="25%"
    >
    <img src="../../assets/img/contact_mf.png" style="width: 100%;"/>   
    </el-dialog>
  </div>
  
</template>
<script>
export default {
  data () {
    return {
      //默认false 弹框隐藏状态    
      videoVisible: false,
    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {
    contact(){
      this.videoVisible = true
    }
  }
};
</script>
<style lang="scss">
.customized_service {
  .banner {
    background: url('../../assets/img/customized_service/banner.jpg') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner .banner_text {
    text-align: center;

    h4 {
      font-size: 50px;
      font-weight: 500;
      color: #ffffff;
    }

    h6 {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      margin-top: 30px;
    }

    .button {
      display: inline-block;
      width: 180px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background: #007bff;
      border-radius: 4px;
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
      margin-top: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customizedService.vue